<template>
  <div class="promt" @touchmove.prevent @click="handleClosePromt" v-if="visible">
    <Join v-if="showJoin" @close="handleCloseJoin"/>
    <Rewards v-if="showRewards && !showJoin" :active="active" :rewards="rewards" @close="handleClosePromt"/>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getTask } from '@/api';
import Join from '@/components/Join';
import Rewards from '@/components/Rewards';

export default {
  name: 'Promt',
  components: {
    Join, Rewards,
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      visible: false,
      showJoin: false,
      showRewards: false,
      rewards: [],
      active: 0,
    };
  },
  methods: {
    async show(opts = {}) {
      const loading = this.$loading();
      const { type = '' } = opts;
      if (type !== 'rewards') {
        const { userInfo = {} } = this;
        this.showJoin = !userInfo?.is_vip;
      }
      const res = await getTask();
      const task = res?.data?.[0]?.progress || {};
      const {
        current = 0, total = 0, all_rewards: rewards = [], today_checked = false,
      } = task;
      this.showRewards = type === 'rewards' ? (current < total) : (!today_checked && current < total);
      this.rewards = rewards;
      this.active = current;
      if (!this.showRewards && !this.showJoin) {
        this.$toast.error('you have no reward task today');
      }
      this.visible = this.showRewards || this.showJoin;
      loading.close();
    },
    handleCloseJoin(str) {
      this.showJoin = false;
      if (str === 'all') {
        this.showRewards = false;
      }
      this.visible = this.showRewards || this.showJoin;
    },
    handleClosePromt() {
      this.visible = false;
      this.$destroy(true);
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
    },
    goDetail() {
      this.$router.push('/app/profile');
    },
  },
};
</script>
<style lang="less" scoped>
.promt {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
